import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { applyLight, resolveLight, setPreference } from "../lib/light";

export const LightToggle = ({ color = "var(--sanctuary-gold)" }) => {
  const [light, setLight] = useState(() => applyLight());
  const isMoon = light === "moon";

  const toggle = () => setLight(setPreference(isMoon ? "dawn" : "moon"));

  return (
    <button
      onClick={toggle}
      data-testid="light-toggle"
      data-light-state={light}
      aria-label={isMoon ? "Switch to dawn light" : "Switch to moonlight"}
      title={isMoon ? "Dawn light" : "Moonlight"}
      className="inline-flex items-center justify-center w-9 h-9 rounded-full transition-opacity hover:opacity-70 cursor-pointer"
      style={{ color }}
    >
      {isMoon ? <Moon className="w-[18px] h-[18px]" strokeWidth={1.25} /> : <Sun className="w-[18px] h-[18px]" strokeWidth={1.25} />}
    </button>
  );
};

export const initLight = () => {
  applyLight();
  // Follow the clock while the tab stays open (e.g. dusk arrives mid-session).
  setInterval(() => applyLight(), 5 * 60 * 1000);
};

export const currentLight = () => resolveLight();
